import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  listClubTournaments,
  registerForClubTournament,
  startTournamentCheckout,
  withdrawClubTournament,
} from "../../components/funtionsBD/competitionService";

function euros(cents) {
  return (Number(cents || 0) / 100).toFixed(2);
}

export default function ClubTournamentBoard() {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [picked, setPicked] = useState({});
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const load = () =>
    listClubTournaments()
      .then((data) => setRows(Array.isArray(data) ? data : []))
      .catch((err) => {
        if (err?.response?.status === 400 || err?.response?.status === 401) return;
        setError(err?.response?.data?.message || err.message);
      });

  useEffect(() => {
    load();
  }, []);

  const toggle = (id, catId) => {
    setPicked((prev) => {
      const cur = new Set(prev[id] || []);
      if (cur.has(catId)) cur.delete(catId);
      else cur.add(catId);
      return { ...prev, [id]: [...cur] };
    });
  };

  const enter = async (row) => {
    const cats = picked[row.competition_id]?.length
      ? picked[row.competition_id]
      : [row.categories?.[0]?.category_id].filter(Boolean);
    if (!cats.length) return;
    setBusy(true);
    setError("");
    try {
      const result = await registerForClubTournament(row.competition_id, cats);
      const status = result?.registration?.registration_status;
      if (status === "pending_payment") {
        const pay = await startTournamentCheckout(
          row.competition_id,
          result.registration.tournament_player_id
        );
        if (pay?.url) {
          window.location.assign(pay.url);
          return;
        }
      }
      await load();
    } catch (err) {
      setError(err?.response?.data?.message || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (!rows.length && !error) return null;

  return (
    <section className="comp-events" aria-labelledby="club-tournaments-title">
      <header className="comp-events__head">
        <h2 id="club-tournaments-title">{t("tourClubEvents", "Club tournaments")}</h2>
        <p>{t("tourClubEventsLede", "Enter an event your club is running.")}</p>
      </header>
      {error ? <p className="comp-page__error">{error}</p> : null}
      {rows.map((row) => (
        <article key={row.competition_id} className="comp-events__card">
          <h3>{row.name}</h3>
          <p>
            {row.event_date || ""}
            {row.entry_fee_cents ? ` · €${euros(row.entry_fee_cents)}` : ` · ${t("tourFree", "Free")}`}
            {row.my_entry ? ` · ${String(row.my_entry.registration_status).replace(/_/g, " ")}` : ""}
          </p>
          {row.registration_open && !row.my_entry ? (
            <>
              <div className="tour-view__chips">
                {(row.categories || []).map((c) => (
                  <button
                    key={c.category_id}
                    type="button"
                    className={(picked[row.competition_id] || []).includes(c.category_id) ? "is-on" : ""}
                    onClick={() => toggle(row.competition_id, c.category_id)}
                  >
                    {c.name}
                  </button>
                ))}
              </div>
              <button type="button" disabled={busy} onClick={() => enter(row)}>
                {t("tourEnter", "Enter")}
              </button>
            </>
          ) : null}
          {row.registration_open && row.my_entry && row.my_entry.registration_status !== "withdrawn" ? (
            <button
              type="button"
              disabled={busy}
              onClick={async () => {
                setBusy(true);
                try {
                  await withdrawClubTournament(row.competition_id);
                  await load();
                } catch (err) {
                  setError(err?.response?.data?.message || err.message);
                } finally {
                  setBusy(false);
                }
              }}
            >
              {t("tourWithdraw", "Withdraw")}
            </button>
          ) : null}
        </article>
      ))}
    </section>
  );
}
